define(["exports", "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose", "react", "styled-components"], function (_exports, _objectWithoutPropertiesLoose2, _react, _styledComponents) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.ResetButton = void 0;
  _objectWithoutPropertiesLoose2 = _interopRequireDefault(_objectWithoutPropertiesLoose2);
  _react = _interopRequireDefault(_react);
  _styledComponents = _interopRequireDefault(_styledComponents);
  var _excluded = ["children"];

  var ResetButtonStyled = _styledComponents.default.button.withConfig({
    displayName: "ResetButton__ResetButtonStyled",
    componentId: "sc-17spct8-0"
  })(["appearance:none;background:none;border:0;cursor:pointer;font-weight:", ";margin:0;padding:0;"], function (_ref) {
    var theme = _ref.theme;
    return theme.font.regular;
  });

  var ResetButton = function ResetButton(_ref2) {
    var children = _ref2.children,
        props = (0, _objectWithoutPropertiesLoose2.default)(_ref2, _excluded);
    return /*#__PURE__*/_react.default.createElement(ResetButtonStyled, props, children);
  };

  _exports.ResetButton = ResetButton;
  ResetButton.defaultProps = {
    onClick: function onClick() {}
  };
});